<template>
  <div id="app">
    <div v-if="loaded === 19 || $store.getters['auth/isAuthenticated'] === false">
      <app-header></app-header>
      <transition name="slide" mode="out-in">
        <router-view></router-view>
      </transition>
      <app-footer></app-footer>
      <vue-snotify></vue-snotify>
    </div>
    <div v-else>
      <div class="col-md-12">
<!--        <div class="row justify-content-md-center" style="width:100%;"><semipolar-spinner :animation-duration="2500" :size="200" :color="'#62a622'" ></semipolar-spinner></div>-->
        <div class="row justify-content-md-center" style="width:100%; font-size: 16px;">
          <img align="center" src="./assets/logo.png" height="200" class="d-inline-block align-top" alt="YMD">
        </div>
        <div class="row justify-content-md-center" style="width:100%; font-size: 16px;">
          <br/><br/>
          <strong>Please Wait..</strong>
        </div>

        <div class="row justify-content-md-center">
          <div class="progress" style="min-width: 600px;">
            <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"
                 :aria-valuenow="loadedPercent" aria-valuemin="0" aria-valuemax="100" v-bind:style="{ width: loadedPercent + '%' }">
              {{loadedPercent}}%
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Header from '@/components/layout/header.vue';
  import Footer from '@/components/layout/footer.vue';
  import axios from 'axios'
  import {SemipolarSpinner} from 'epic-spinners'

  export default {
    name: 'App',
    components: {
      appHeader: Header,
      appFooter: Footer,
      SemipolarSpinner: SemipolarSpinner,
    },
    data () {
      return {
        loaded: 0,
      }
    },

    mounted(){
      this.loadEnvironment();
      this.loadData();
      this.interval = setInterval(function () {
        this.loadData();
      }.bind(this), 300000);

        this.interval2 = setInterval(function () {
            this.$store.dispatch('security/fetchUserPermissions')
        }.bind(this), 5000);

    },
    methods: {
      loadData() {
        // All functions where periodic check is required.
          if (this.$store.getters['auth/isAuthenticated'] === true) {
              // this.$store.dispatch('shifts/makeAttendance');
              this.$store.dispatch('holidays/syncHolidays');
              this.$store.dispatch('shifts/makePlans');
          }
      },

      loadEnvironment() {
        // Check if user is authenticated
        //   this.$store.dispatch('auth/logout');
        if (this.$store.getters['auth/isAuthenticated'] === true) {
          // Fetch Account and Profile Data
            this.$store.dispatch('security/fetchUserPermissions')
            this.$store.dispatch('user/getUserProfile')
            .then(response => {++this.loaded}) .catch(error => {
                this.$snotify.error(error.error.message, error.error.title);
                this.$store.dispatch('auth/logout');
            });
          // Fetch All Users
          this.$store.dispatch('user/fetchUsers')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Fetch All Units
          this.$store.dispatch('environment/fetchDivisions')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Fetch All Units
          this.$store.dispatch('environment/fetchBranches')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Timezones
          this.$store.dispatch('environment/fetchDepartments')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Timeformats
          this.$store.dispatch('environment/fetchDesignations')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Countries
          this.$store.dispatch('environment/fetchCompanies')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          this.$store.dispatch('environment/fetchSponsorCompanies')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Languages
          this.$store.dispatch('environment/fetchReligions')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Currencies
          this.$store.dispatch('environment/fetchNationalities')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Currencies
          this.$store.dispatch('environment/fetchGroups')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Currencies
          this.$store.dispatch('environment/fetchCities')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          this.$store.dispatch('user/fetchUsers')
            .then(response => {++this.loaded}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Shift Plans
          this.$store.dispatch('shifts/fetchShiftPlans')
                  .then(response => {++this.loaded;}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Leave Types
          this.$store.dispatch('leaves/fetchLeaveTypes')
                  .then(response => {++this.loaded;}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          this.$store.dispatch('machines/fetchMachines')
                  .then(response => {++this.loaded;}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
            // Load HR Settings
            this.$store.dispatch('environment/fetchSettingsHR')
                .then(response => {++this.loaded;}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
            // Load Public Holidays
            this.$store.dispatch('holidays/fetchHolidays')
                .then(response => {++this.loaded;}) .catch(error => {
                this.$snotify.error(error.error.message, error.error.title);
                });
            // Fetch Shift Types
            this.$store.dispatch('shifts/fetchShiftCategories')
                .then(response => {++this.loaded;}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});

            // TODO: Load Company Settings

        }

      },

      loadUsersData() {
        // TODO: Load All Users

        // TODO: Load Profile

        // TODO: Load Permissions

        // TODO: Load User Settings
      }
    },

    beforeDestroy: function(){
        clearInterval(this.interval);
        clearInterval(this.interval2);
    },

    computed: {
      loadedPercent(){
        return (this.loaded/19*100).toFixed(0)
      }
    },

  }
</script>
<style>
  #app {
    font-family: 'Source Sans Pro', 'Roboto', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 40px;
  }

  body{
    font-size: 13px;
    font-family: 'Roboto', 'Source Sans Pro', Helvetica, Arial, sans-serif;
  }
  a{
    color:#3d6e9e;
  }
  /* width */
  ::-webkit-scrollbar {
    width: 15px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #cdcdcd;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  .shadows{
    -webkit-box-shadow: 1px 5px 28px -8px rgba(99,99,99,1);
    -moz-box-shadow: 1px 5px 28px -8px rgba(99,99,99,1);
    box-shadow: 1px 5px 28px -8px rgba(99,99,99,1);
    background-color: white;
    border: 1px solid #bababa;
  }
  h6{
    font-weight: bold;
    padding-top: 7px;
    font-size: 14px;
  }
  .padded10 {
    padding: 10px;
  }

  .form-control{
    font-size: 0.8rem;
  }

  .btn{
    font-size: 0.8rem;
    padding-top: 5px;
    padding-bottom: 2px;
  }

  .breadcrumb{
    border: solid 1px #e0e0e0;
    background-color: #fdfdfe;
    padding: 0.25rem 1rem;
    border-radius: 0;
    margin-top: 7px;
  }

  .breadcrumb a{
    font-size: 0.8rem;
    color: #23272b;
  }

  .breadcrumb li{
    font-size: 0.8rem;
  }

  .is-danger-input{
    border: 1px solid darkred;
    background-color: #FFE9EB;
  }

  .menu_vertical_parent{
    margin-bottom: 7px;  top: 7px; cursor: pointer;
  }
  .menu_vertical_child{
    padding-left: 40px; cursor: pointer; height: 35px; padding-top: 8px; font-size: 14px;
  }
  .list-group-item.active{
    background-color: #808080;
    border-color: #808080;
  }
  .list-group-item:first-child{
    border-top-left-radius: 0;
    border-top-right-radius: 0
  }
  .list-group-item:last-child{
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .list-group-item-light{
    color: #383838;
    font-size: 1em;
    font-weight: bold;
    background-color: #f9f9f9;
  }
  .menu_vertical_child{
    font-size: 0.87em !important;
  }

  .actions {
    background-color: #f8f8f8;
    padding: 5px 15px 15px 15px;
    height:50px;
    align-items: center;
    display : flex;
    border-bottom: solid 1px #eee;
    box-shadow: 2px 2px #eee;
    margin-bottom: 10px;
  }

  .left {
    /*padding: 15px;*/
    border-right:solid 1px #f4f4f4;
    min-width: 250px;
    max-width: 250px !important;
    background-color: #f7f7f7;
    box-shadow: 2px 2px #eee;
    margin-top: -7px;

  }
  .left250 {
    min-width: 250px;
    max-width: 250px;
  }
  .left200 {
    min-width: 200px;
    max-width: 200px;
    height: 86vh;
    overflow-x: hidden;
    overflow-y: auto;
    border-right: solid 1px #f0f0f0;
    box-shadow: 2px 2px #eee;
  }
  .left200a {
    min-width: 200px;
    max-width: 200px;
    height: 86vh;
    border-right: solid 1px #f0f0f0;
    box-shadow: 2px 2px #eee;
    padding: 0px;
  }
  .left200b {
    min-width: 200px;
    max-width: 200px;
    height: 78vh;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 10px;
  }
  .left10 {
    min-width: 10px;
    max-width: 10px;
  }
  .leftToggle {
    position: fixed;
    display: block;
    left: 184px;
    top: 40vh;
    border: 1px solid #dcdcdc;
    border-radius: 5px 0px 0px 5px;
    color: #858585;
    padding: 2px 2px 0px 4px;
    border-right: none;
    cursor: pointer;
    background-color: white;
  }
  .leftToggleBack {
    position: fixed;
    display: block;
    left: 15px;
    top: 40vh;
    border: 1px solid #dcdcdc;
    border-right: none;
    border-radius: 5px 0px 0px 5px;
    color: #858585;
    padding: 2px 2px 0px 4px;
    cursor: pointer;
    background-color: white;
  }

  .right {
    padding: 15px;
    border-left:solid 1px #eee;
    min-width: 300px;
    max-width: 300px;
    background-color: #f7f7f7;
    box-shadow: 2px 2px #eee;
    max-height: 86vh;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .right300 {
    min-width: 300px;
    max-width: 300px;
  }
  .right250 {
    min-width: 250px;
    max-width: 250px;
  }
  .right200 {
    min-width: 200px;
    max-width: 200px;
    height: 85vh;
    overflow-x: hidden;
    overflow-y: auto;
    border-left: solid 1px #f0f0f0;
    box-shadow: 2px 2px #eee;

  }

  .content {
    min-height:78vh;
    max-height:86vh;
  }
  .footer{
    width: 100%;
    height: 34px;
    background-color: #f8f8f8;
    padding-top: 7px;
    text-align: center;
    color: #858585;
    font-size: 12px;
    box-shadow: 2px 2px 2px 2px #eee;

  }

  .paddingTop5 {
    padding-top: 5px;
  }

  .standout {
    padding: 10px;
    background-color: #f8f8f8;
    border: solid 1px #f0f0f0;
    box-shadow: 0px 0px 2px 0px #eee;

  }

  .dropdown-item{
    font-size: 12px;
  }

  .snooze-list{
    background-color: #fafafa; cursor: pointer; min-width: 300px; max-width:300px; border: solid 1px #dddddd; padding: 20px; margin: 15px; font-size: 18px; box-shadow: 0 4px 4px 0 #eeeeee;
  }

  .circleGreen {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 14px;
    color: #fff;
    line-height: 37px;
    text-align: center;
    background: #3fa52f;
  }
  .circleBlue {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 14px;
    color: #fff;
    line-height: 37px;
    text-align: center;
    background: #3655a5;
  }

  .multiselect__tags{
    min-height: 30px;
    padding-top: 5px;
  }
  .custom__tag{
    display: inline-block;
    padding: 3px 12px;
    background-color: #d2d7ff;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 12px;
  }
  .custom__remove{
    padding: 0px;
    font-size: 10px;
    margin-left: 5px;
  }
  .multiselect__input, .multiselect__single{
    font-size: 13px;
  }
  .multiselect__content{
    font-size: 13px;
  }


  .nav-item{
    padding-right: 8px;
  }
  .nav-item a{
    font-size: 14px;
  }

  .fa-icon{
    padding-right: 2px;
    vertical-align: middle !important;
    margin-bottom: 4px;
  }

  .help{
    color: darkred;
    font-size: 12px;
    font-weight: bold;
  }

  .snotify{
    width:400px !important;
  }
  .snotifyToast__title{
    font-size: 1.4em !important;;
  }
  .snotifyToast__body{
    font-size: 0.9em !important;;
  }

  .vertical-align {
    display: flex;
    align-items: center;
  }

  .highlighted{
    background-color: #EDEDED;
  }
  .prehighlight{
    cursor: pointer;
    padding-bottom: 10px;
    padding-top: 20px;
  }
  .prehighlight:hover{
    background-color: #EDEDED;
  }


  .radiobox {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 18px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  /* Hide the browser's default radio button */
  .radiobox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }
  /* On mouse-over, add a grey background color */
  .radiobox:hover input ~ .checkmark {
    background-color: #ccc;
  }
  /* When the radio button is checked, add a blue background */
  .radiobox input:checked ~ .checkmark {
    background-color: #2196F3;
  }
  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  /* Show the indicator (dot/circle) when checked */
  .radiobox input:checked ~ .checkmark:after {
    display: block;
  }
  /* Style the indicator (dot/circle) */
  .radiobox .checkmark:after {
      top: 9px;
      left: 9px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: white;
  }
  .radioboxDiv{
      width: 45%;
      min-width: 400px;
      margin: 0 auto;
      border: solid 1px #c6c6c6;
      padding: 10px;
      padding-top: 18px;
      margin-bottom: 10px;
      padding-left: 15px;
  }

  .heading-background{
      padding: 10px;
      border: solid 1px #c6c6c6;
      background-color: #f7f7f7;
      margin-top: 5px;
      margin-bottom: 5px;
  }

  .shadow{
    -webkit-box-shadow: 0 7px 4px -8px #777;
    -moz-box-shadow: 0 7px 4px -8px #777;
    box-shadow: 0 7px 4px -8px #777;
  }

  .slide-enter-active {
    animation: slide-in 300ms ease-out forwards;
  }
  .slide-leave-active {
    animation: slide-out 300ms ease-out forwards;
  }
  @keyframes slide-in {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes slide-out {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(-30px);
      opacity: 0;
    }
  }

  .headerTabDiv{
    height: 25px;
    background-color: rgb(230, 230, 230);
    padding-top: 4px;
    padding-right: 10px;
    border-bottom: solid 1px #bfbfbf;
  }
  .headerTab{
    padding: 2px 5px 2px 5px;
    background-color: #f8f8f8;
    border: 1px solid rgb(162, 162, 162);
    color: #57616b;
    font-size: 11px;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
  }
  .headerTab:hover{
    background-color: rgb(52, 58, 64);
    color: #d8d8d8;
  }

  .subjectDiv{
    height: 70px; background-color: #fcfcfc !important; margin-top: -8px !important; padding-right: 0px;
  }
  .threadContentAreaDiv{
    padding: 15px; height: 64vh; overflow-x: hidden; overflow-y: auto; background-color: #fcfcfc; margin-top: -8px;
  }
  .logDiv{
    margin-bottom: 10px; font-size: 12px; border-left: solid 3px #71bf27; color: #727272; padding-top: 5px;
  }
  .eventsDiv{
    font-size: 13px; min-height: 65px; border: solid 1px #dcdcdc; border-left: solid 5px #99b3f5; box-shadow: 4px 4px 4px 0 #eee; padding-top: 12px; padding-bottom: 5px; margin-bottom: 4px;
  }
  .noteDiv{
    background-color: #ffffed;
  }
  .messageDiv{
    background-color: white;
  }
  .replyExternalDiv{
    background-color: #f7fbff;
  }
  .replyEmailDiv{
    background-color: white;
  }
  .threadHeaderLeft{
    width: 50px;
  }
  .threadHeaderRight{
    /*margin-top: 8px;*/
  }
  .threadBody{
    padding: 15px; font-size: 13px;  padding-left: 64px;
  }
  .replyAreaTabs{
    padding-top: 12px; background-color: #fcfcfc;
  }
  .replyAreaBody{
    background-color: white; border: solid 1px #c7c7c7; box-shadow:4px 4px 4px 0 #eeeeee; width: 100%;
  }
  .repyAreaFilesDiv{
    border: solid 1px #eee; padding: 5px; margin: 5px;
  }
  .replyRow{
    padding: 10px !important; border-bottom: solid 1px #eee !important;
  }
  .replyLabel{
    min-width:100px; max-width:100px; padding-top: 12px;
  }
  .replyContent{
    padding-top: 12px;
  }
  .tabsDiv{
    margin-top: -10px;
    height: 40px;
    background-color: white;
    margin-bottom: 11px;
    box-shadow: 3px 2px 0 0 #e0e0e0;
  }
  .tabsDiv a{
    padding: 12px 20px 12px 20px;
    cursor: pointer;
    font-size: 12px;
    color: #535353;
  }
  .tabsDiv a:hover{
    color: black;
    text-decoration: none;
    background-color: #f8f8f8;
  }
  .tabsDivActive{
    color: #4470e3 !important;
    text-decoration: none !important;
  }

  .replyActionButton{
    margin-right: 5px; cursor: pointer;
  }
  .replyActionButton button{
    margin-top: 10px; margin-bottom: 10px; background-color: white; border: solid 1px #6b6b6b; border-radius: 4px; color: #555;
  }
  .replyActionButton :hover{
    background-color: #0c5460 !important; color: white !important;
  }
  .replyBoxRightSection {
    width: 300px;
    height: 292px;
    border: solid 1px #c7c7c7;
    margin-right: 10px;
    box-shadow: 2px 4px 4px 1px #eee;
    padding: 0;
    background-color: #fafdff;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .replyBoxRightSectionHeader{
    border-bottom: solid 1px #c7c7c7; width:100%; float: left; padding: 12px; height: 42px; text-align: center;
  }
  .replyBoxRightSectionBody{
    width:100%; float: left; padding: 12px;
  }
  @media print
  {
    .no-print, .no-print *
    {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue